import React from "react";

// Styles
import "./ModalErrorMessage.scss"

export const ModalErrorMessage = ({msg}) => 
    <div className="error-msg-box">
        {msg}
    </div>
